import type { QRConfig } from "@/pages/generator/page";

interface Props {
  config: QRConfig;
  onChange: (partial: Partial<QRConfig>) => void;
  onNext: () => void;
  onBack: () => void;
}

const typeLabels: Record<string, string> = {
  url: "İnternet Sitesi",
  vcard: "vCard",
  wifi: "WiFi",
  text: "Metin",
  email: "E-posta",
  phone: "Telefon",
  instagram: "Instagram",
  whatsapp: "WhatsApp",
  facebook: "Facebook",
  pdf: "PDF",
};

const placeholders: Record<string, string> = {
  url: "https://example.com",
  vcard: "Ad Soyad, Telefon, E-posta bilgilerini girin",
  wifi: "SSID:AğAdı;T:WPA;P:Şifre;;",
  text: "QR kodunuzda görünecek metni girin",
  email: "ornek@email.com",
  phone: "+90 555 000 00 00",
  instagram: "https://instagram.com/kullanici",
  whatsapp: "+90 555 000 00 00",
  facebook: "https://facebook.com/sayfa",
  pdf: "https://example.com/dosya.pdf",
};

export default function QRContentForm({ config, onChange, onNext, onBack }: Props) {
  const isValid = config.content.trim().length > 0;

  return (
    <div>
      <h2 className="text-xl font-bold text-slate-900 mb-2">İçerik Ekleyin</h2>
      <p className="text-sm text-slate-500 mb-6">
        <span className="font-medium text-blue-600">{typeLabels[config.type]}</span> QR kodu için içeriğinizi girin.
      </p>

      <div className="bg-white rounded-2xl border border-slate-100 p-6">
        {config.type === "wifi" ? (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Ağ Adı (SSID)</label>
              <input
                type="text"
                placeholder="WiFi ağ adı"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors"
                onChange={(e) => onChange({ content: `WIFI:S:${e.target.value};T:WPA;P:;;` })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Şifre</label>
              <input
                type="password"
                placeholder="WiFi şifresi"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Güvenlik Türü</label>
              <select className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors cursor-pointer">
                <option>WPA/WPA2</option>
                <option>WEP</option>
                <option>Şifresiz</option>
              </select>
            </div>
          </div>
        ) : config.type === "vcard" ? (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Ad</label>
                <input type="text" placeholder="Adınız" className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Soyad</label>
                <input type="text" placeholder="Soyadınız" className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Telefon</label>
              <input type="tel" placeholder="+90 555 000 00 00" className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors"
                onChange={(e) => onChange({ content: `BEGIN:VCARD\nVERSION:3.0\nTEL:${e.target.value}\nEND:VCARD` })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">E-posta</label>
              <input type="email" placeholder="ornek@email.com" className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Web Sitesi</label>
              <input type="url" placeholder="https://example.com" className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors" />
            </div>
          </div>
        ) : (
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              {typeLabels[config.type]} İçeriği
            </label>
            {config.type === "text" ? (
              <textarea
                rows={4}
                placeholder={placeholders[config.type]}
                value={config.content}
                onChange={(e) => onChange({ content: e.target.value })}
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors resize-none"
              />
            ) : (
              <input
                type="text"
                placeholder={placeholders[config.type]}
                value={config.content}
                onChange={(e) => onChange({ content: e.target.value })}
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-colors"
              />
            )}
            <p className="text-xs text-slate-400 mt-2">
              {config.content.length} karakter
            </p>
          </div>
        )}
      </div>

      <div className="flex gap-3 mt-6">
        <button
          onClick={onBack}
          className="flex items-center gap-2 px-5 py-2.5 border border-slate-200 text-slate-600 text-sm font-medium rounded-full hover:bg-slate-50 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          Geri
        </button>
        <button
          onClick={onNext}
          disabled={!isValid}
          className="flex-1 flex items-center justify-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap"
        >
          Tasarıma Geç
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
    </div>
  );
}
